import React, { useCallback, useState, useRef, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { HiChevronDoubleRight } from 'react-icons/hi'
import DatePicker from 'react-datepicker'
import { toast } from 'react-toastify'
import { createTask } from '../../Api/task'
import Dropdown from '../Dropdown/Dropdown'
import 'react-datepicker/dist/react-datepicker.css'
import './task.css'

const AddTask = ({ assignees, tags, priorities }) => {
  const tage = tags.map(({ label }) => label)
  const result = tage.map((label, i) => ({ label, value: tage[i] }))

  const titleRef = useRef(null)
  const priorityButtonRef = useRef(null)
  const assigneeButtonRef = useRef(null)
  const tagButtonRef = useRef(null)
  const statusButtonRef = useRef(null)
  const privateButtonRef = useRef(null)
  const notifyMembersButtonRef = useRef(null)
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const [priority, setPriority] = useState('')
  const [assignee, setAssignee] = useState([])
  const [tag, setTag] = useState([])
  const [status, setStatus] = useState(searchParams.get('card'))
  const [isPrivate, setIsPrivate] = useState(false)
  const [notifyMembers, setNotifyMembers] = useState([])
  const [state, setState] = useState({
    title: '',
    dueDate: '',
    description: '',
  })
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const changeHandler = useCallback((event) => {
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }))
  }, [])

  useEffect(() => {
    if (titleRef?.current) {
      titleRef.current.focus()
    }
  }, [])

  useEffect(() => {
    if (searchParams.get('card')) {
      setStatus(searchParams.get('card'))
    }
  }, [searchParams])

  const createTaskHandler = useCallback(async () => {
    const cleanData = {
      title: state.title.trim(),
      description: state.description.trim(),
      dueDate: state.dueDate,
      isPrivate: isPrivate,
      assignee:
        assignee?.length > 0
          ? [
            ...assignee.map((email) => ({
              email: email,
            })),
          ]
          : [],
      tag:
        tag?.length > 0
          ? [
            ...tag.map((tag) => ({
              tag: tag,
            })),
          ]
          : [],
      priority: priority,
      status: status,
    }
    if (cleanData.title === '') {
      toast.error('Please fill the title of the task')
    } else if (!cleanData.dueDate) {
      toast.error('Please fill the due date of the task')
    } else if (cleanData.assignee?.length <= 0) {
      toast.error('Please select atleast one assignee for the task')
    } else {
      const apiResponse = await createTask(cleanData)
      if (apiResponse) {
        setState({
          title: '',
          dueDate: '',
          description: '',
        })
        setPriority('')
        setIsPrivate(false)
        setStatus('')
        setAssignee([])
        setTag([])
        navigate(
          `/tasks/?tag=${
            searchParams.get('tag') &&
            searchParams.get('tag') !== 'null' &&
            searchParams.get('tag')
          }&task=${apiResponse._id}&card=`
        )
      }
    }
  }, [
    assignee,
    tag,
    state,
    status,
    priority,
    isPrivate,
    searchParams,
    navigate,
  ])

  return (
    <div className={searchParams.get('card') ? 'task active' : 'task'}>
      <div className='actions'>
        <button
          onClick={() =>
            navigate(
              `/tasks/?tag=${
                searchParams.get('tag') &&
                searchParams.get('tag') !== 'null' &&
                searchParams.get('tag')
              }&task=&card=`
            )
          }
        >
          <HiChevronDoubleRight size={16} />
        </button>
      </div>
      <div className='content'>
        <textarea
          name='title'
          onChange={changeHandler}
          className='title'
          spellCheck={false}
          rows={3}
          value={state?.title}
          placeholder='Untitled'
          ref={titleRef}
        />
        <ul>
          <li className='duedate' value={state.dueDate}>
            <div className='header'>
              📅 <span>Due date</span>
            </div>
            <p
              className={
                state?.dueDate &&
                (new Date(state.dueDate).getTime() < new Date().getTime()
                  ? 'overdue'
                  : new Date(state.dueDate).getTime() >=
                    new Date().getTime() - 7 * 86400000
                    ? 'warn'
                    : '')
              }
            >
              {state?.dueDate &&
                `${months[new Date(state?.dueDate).getMonth()]} ${new Date(
                  state?.dueDate
                ).getDate()}, ${new Date(state?.dueDate).getFullYear()}`}
            </p>
            <DatePicker
              selected={state.dueDate ? new Date(state.dueDate) : new Date()}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  dueDate: new Date(e),
                }))
              }
              dateFormat='Pp'
              minDate={new Date()}
              maxDate={
                new Date(new Date().getTime() + 60 * 60 * 24 * 1000 * 365)
              }
            />
          </li>
          <li>
            <div className='header'>
              🚦 <span>Priority</span>
            </div>
            <div className='filter'>
              <button
                className={
                  priority ? 'tag-filter-button active' : 'tag-filter-button'
                }
                ref={priorityButtonRef}
              >
                {priority ? priority.split('_')[1] : 'Empty'}
              </button>
              <Dropdown
                isMultiple={false}
                data={priorities}
                setActiveFilters={setPriority}
                activeFilters={priority}
                ref={priorityButtonRef}
              />
            </div>
          </li>
          <li className='assignee'>
            <div className='header'>
              🙋‍♀️ <span>Assignee</span>
            </div>
            <div className='filter'>
              <button
                className={
                  assignee?.length > 0
                    ? 'tag-filter-button active'
                    : 'tag-filter-button'
                }
                ref={assigneeButtonRef}
              >
                {assignee?.length > 0 ? assignee.join(', ') : 'Empty'}
              </button>
              <Dropdown
                isMultiple={true}
                isSearchable={true}
                data={assignees}
                setActiveFilters={setAssignee}
                activeFilters={assignee}
                ref={assigneeButtonRef}
              />
            </div>
          </li>
          <li>
            <div className='header'>
              🔓 <span>Nature</span>
            </div>
            <div className='filter'>
              <button
                className={
                  priority ? 'tag-filter-button active' : 'tag-filter-button'
                }
                ref={privateButtonRef}
              >
                {isPrivate ? 'Private' : 'Shared'}
              </button>
              <Dropdown
                isMultiple={false}
                data={[
                  {
                    value: true,
                    label: 'Private',
                  },
                  {
                    value: false,
                    label: 'Shared',
                  },
                ]}
                setActiveFilters={setIsPrivate}
                activeFilters={isPrivate}
                ref={privateButtonRef}
              />
            </div>
          </li>
          <li className='static'>
            <div className='header'>
              👥 <span>Meeting</span>
            </div>
            <p>N/A</p>
            <p></p>
          </li>
          <li>
            <div className='header'>
              🏷️ <span>Tags</span>
            </div>
            <div className='filter'>
              <button
                className={
                  tag?.length > 0
                    ? 'tag-filter-button active'
                    : 'tag-filter-button'
                }
                ref={tagButtonRef}
              >
                {tag?.length > 0 ? tag.join(', ') : 'Empty'}
              </button>
              <Dropdown
                isMultiple={true}
                isSearchable={true}
                data={result}
                setActiveFilters={setTag}
                activeFilters={tag}
                ref={tagButtonRef}
              />
            </div>
            <p></p>
          </li>
          <li>
            <div className='header'>
              ⚙️ <span>Status</span>
            </div>
            <div className='filter'>
              <button
                className={
                  status ? 'tag-filter-button active' : 'tag-filter-button'
                }
                ref={statusButtonRef}
              >
                {status
                  ? status === 'IN_PROGRESS'
                    ? 'IN PROGRESS'
                    : status
                  : 'Empty'}
              </button>
              <Dropdown
                isMultiple={false}
                data={[
                  { value: 'TODO', label: 'TODO' },
                  { value: 'IN_PROGRESS', label: 'IN PROGRESS' },
                  { value: 'DONE', label: 'DONE' },
                ]}
                setActiveFilters={setStatus}
                activeFilters={status}
                ref={statusButtonRef}
              />
            </div>
          </li>
          <li className='assignee'>
            <div className='header'>
              🔔 <span>Reminder</span>
            </div>
            <div className='filter'>
              <button
                className={
                  notifyMembers?.length > 0
                    ? 'tag-filter-button active'
                    : 'tag-filter-button'
                }
                ref={notifyMembersButtonRef}
              >
                {notifyMembers?.length > 0 ? notifyMembers.join(', ') : 'Empty'}
              </button>
              <Dropdown
                isMultiple={true}
                isSearchable={true}
                data={assignees}
                setActiveFilters={setNotifyMembers}
                activeFilters={notifyMembers}
                ref={notifyMembersButtonRef}
              />
            </div>
          </li>
        </ul>
        <div className='description'>
          <span>
            📝 <em>description</em>
          </span>
          <textarea
            placeholder='Enter a description...'
            name='description'
            onChange={changeHandler}
            spellCheck={false}
            rows={3}
            value={state?.description}
          />
        </div>
        <div className='submit'>
          <button onClick={createTaskHandler}>Create Task</button>
        </div>
      </div>
    </div>
  )
}

export default AddTask
